import { api } from "@/api"
import { useQuery } from "@tanstack/vue-query"

export type RetrieveTransactionReceiptData = {
  receipt: string
}

type RetrieveTransactionReceiptQuery = {
  isMerchant: boolean
}

export const retrieveTransactionReceipt = async (
  transactionId: string,
  query?: RetrieveTransactionReceiptQuery
) => {
  const { body } =
    await api.get<RetrieveTransactionReceiptData>(
      `/transactions/${transactionId}/receipt/`,
      { query }
    )
  return body
}

export const useTransactionReceipt = (
  transactionId: MaybeRef<string>,
  query?: MaybeRef<RetrieveTransactionReceiptQuery>
) =>
  useQuery({
    queryKey: [
      "transactionReceipt",
      transactionId,
      query,
    ] as const,
    queryFn: ({ queryKey: [_, transactionId_, query_] }) =>
      retrieveTransactionReceipt(transactionId_, query_),
    refetchInterval: Infinity,
    staleTime: 0,
  })
